'use es6';

import PropTypes from 'prop-types';
import { cloneElement, Children, Component } from 'react';
import { DragLayer } from 'react-dnd';
import { jsx as _jsx } from "react/jsx-runtime";
const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 0,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};
function getItemStyles(props) {
  const {
    initialOffset,
    currentOffset
  } = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }
  const {
    x,
    y
  } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform
  };
}
class CustomDragLayer extends Component {
  renderItem() {
    const {
      item,
      children
    } = this.props;
    if (!item.useCustomDragLayer) {
      return null;
    }
    const child = Children.only(children);
    return /*#__PURE__*/cloneElement(child, {
      item
    });
  }
  render() {
    const {
      isDragging,
      itemType,
      namespace
    } = this.props;
    if (!isDragging || namespace && namespace !== itemType) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      style: layerStyles,
      children: /*#__PURE__*/_jsx("div", {
        style: getItemStyles(this.props),
        children: this.renderItem()
      })
    });
  }
}
CustomDragLayer.propTypes = {
  namespace: PropTypes.string,
  children: PropTypes.node,
  isDragging: PropTypes.bool.isRequired,
  item: PropTypes.object,
  itemType: PropTypes.string,
  initialOffset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),
  currentOffset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  })
};
export { CustomDragLayer as WrappedComponent };
export default DragLayer(monitor => {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
})(CustomDragLayer);